import React from "react";

import FbIconSvg from "../../resources/SvgComponents/FbIconSvg";
import { StyledContainer, StyledIcon } from "./SocialMediaItemsStyle";
import LinkedInIconSvg from "../../resources/SvgComponents/LinkedInIconSvg/LinkedInIconSvg";

const SocialMediaItems = () => {
  return (
    <StyledContainer>
      <StyledIcon>
        <a
          aria-label="facebook-kvalifika"
          href="https://www.facebook.com/kvalifika"
          target="_blank"
          rel="noreferrer"
        >
          <FbIconSvg />
        </a>
      </StyledIcon>
      <StyledIcon>
        <a
           href="https://www.linkedin.com/company/kvalifika/"
           target="_blank"
           aria-label="linkedin-kvalifika"
           rel="noreferrer"
        >
          <LinkedInIconSvg />
        </a>
      </StyledIcon>
    </StyledContainer>
  );
};

export default SocialMediaItems;
